const addBtn = document.querySelectorAll(".apex-upsell-options button");
const addBtnV6 = document.querySelectorAll(
  ".apex-upsell-image--container button"
);
const multiAddBtn = document.querySelectorAll("button.apex-upsell-multi-add");
const closeBtn = document.querySelectorAll(".apex-upsell-modal--header button");

addBtn.forEach((btn) =>
  btn.addEventListener("click", function (e) {
    const parentType =
      this.parentElement.parentElement.parentElement.parentElement.parentElement
        .dataset.type;
    if (parentType == "upsell-v5") {
      const selectElement = this.parentElement.parentElement.querySelector(
        ".apex-upsell-options select"
      );
      const inputElement = this.parentElement.parentElement.querySelector(
        "input[type='hidden']"
      );
      const multiAddBtn =
        this.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
          "button.apex-upsell-multi-add"
        );
      let variantId;
      if (selectElement) {
        const selectValue = selectElement.value || selectElement.defaultValue;
        variantId = selectValue;
      } else {
        variantId = inputElement.value || inputElement.defaultValue;
      }

      if (this.querySelector("span").textContent !== "SELECTED") {
        this.querySelector("span").textContent = "SELECTED";
        if (selectElement) {
          selectElement.setAttribute("disabled", "disabled");
        }
        if (multiAddBtn) {
          const selectedVariants = JSON.parse(multiAddBtn.dataset.selected);
          selectedVariants.push({
            id: variantId,
            quantity: 1,
          });
          multiAddBtn.setAttribute(
            "data-selected",
            JSON.stringify(selectedVariants)
          );
          multiAddBtn.removeAttribute("disabled");
          multiAddBtn.querySelector("span").innerText = selectedVariants.length;
        }
      } else {
        this.querySelector("span").textContent = "SELECT";
        if (selectElement) {
          selectElement.removeAttribute("disabled");
        }
        if (multiAddBtn) {
          let selectedVariants = JSON.parse(multiAddBtn.dataset.selected);
          selectedVariants = selectedVariants.filter((o) => o.id !== variantId);
          multiAddBtn.setAttribute(
            "data-selected",
            JSON.stringify(selectedVariants)
          );
          if (selectedVariants.length == 0) {
            multiAddBtn.setAttribute("disabled", "");
          }
          multiAddBtn.querySelector("span").innerText = selectedVariants.length;
        }
      }
    } else {
      const siblingElement = this.previousElementSibling;
      let variantId;
      if (siblingElement.nodeName == "DIV") {
        const selectValue =
          siblingElement.querySelector("select").value ||
          siblingElement.querySelector("select").defaultValue;
        variantId = selectValue;
      } else {
        variantId = siblingElement.value || siblingElement.defaultValue;
      }
      this.textContent = "ADDING";
      let formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      };
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          this.textContent = "ADDED";
          this.setAttribute("disabled", "disabled");
          theme.ajaxCart.update();
          return response.json();
        })
        .catch((error) => {
          this.textContent = "ADD";
          console.error("Error:", error);
        });
    }
  })
);

closeBtn.forEach((btn) =>
  btn.addEventListener("click", function () {
    this.closest(".apex-upsell-modal").style.display = "none";
  })
);

addBtnV6.forEach((btn) =>
  btn.addEventListener("click", function () {
    const selectElement =
      this.parentElement.parentElement.parentElement.querySelector(
        ".apex-upsell-options select"
      );
    const inputElement =
      this.parentElement.parentElement.parentElement.querySelector(
        "input[type='hidden']"
      );
    const multiAddBtn =
      this.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
        "button.apex-upsell-multi-add"
      );
    let variantId;
    if (selectElement) {
      const selectValue = selectElement.value || selectElement.defaultValue;
      variantId = selectValue;
    } else {
      variantId = inputElement.value || inputElement.defaultValue;
    }

    if (this.querySelector("span").textContent !== "SELECTED") {
      this.querySelector("span").textContent = "SELECTED";
      if (selectElement) {
        selectElement.setAttribute("disabled", "disabled");
      }
      if (multiAddBtn) {
        const selectedVariants = JSON.parse(multiAddBtn.dataset.selected);
        selectedVariants.push({
          id: variantId,
          quantity: 1,
        });
        multiAddBtn.setAttribute(
          "data-selected",
          JSON.stringify(selectedVariants)
        );
        multiAddBtn.removeAttribute("disabled");
        multiAddBtn.querySelector("span").innerText = selectedVariants.length;
      }
    } else {
      this.querySelector("span").textContent = "SELECT";
      if (selectElement) {
        selectElement.removeAttribute("disabled");
      }
      if (multiAddBtn) {
        let selectedVariants = JSON.parse(multiAddBtn.dataset.selected);
        selectedVariants = selectedVariants.filter((o) => o.id !== variantId);
        multiAddBtn.setAttribute(
          "data-selected",
          JSON.stringify(selectedVariants)
        );
        if (selectedVariants.length == 0) {
          multiAddBtn.setAttribute("disabled", "");
        }
        multiAddBtn.querySelector("span").innerText = selectedVariants.length;
      }
    }
  })
);

document.querySelectorAll(".apex-upsell-btn--checkbox").forEach((customBtn) =>
  customBtn.addEventListener("click", function (e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    const checkbox = this.querySelector("input");
    if (checkbox.checked) {
      checkbox.removeAttribute("checked");
      this.querySelector("span").innerText = "ADD";
    } else {
      checkbox.setAttribute("checked", "checked");
      this.querySelector("span").innerText = "ADDED";
    }
  })
);

document
  .querySelector("button[name='add']")
  .addEventListener("click", function (e) {
    e.preventDefault();

    this.classList.add("btn--loading");
    this.setAttribute("disabled", "disabled");
    
    const mainProductVariantId =
      this.parentElement.parentElement.querySelector("select[name='id']").value;
    const mainProductQuantity = this.parentElement.parentElement.querySelector( "input[name='quantity']" ).value;
    var mainProductSellingId = '';
    if(this.parentElement.parentElement.querySelector("input[name='selling_plan']")!=null){
       mainProductSellingId = this.parentElement.parentElement.querySelector("input[name='selling_plan']").value;
    }
    let items = [
      {
        id: mainProductVariantId,
        quantity: mainProductQuantity,
       selling_plan: mainProductSellingId
      },
    ];
    if(jQuery('body').find('#freeMiniShinProduct').length>0 && getCookie('freeProductId')==null){
      if(jQuery('#free_minipad_pro').is(":checked")){
        items.push({id:44299606065375,quantity: 1,properties:{'_freeProduct':'1'}});
        var expires = new Date();
        var cookieKey = 'freeProductId';
        var cookieValue = '44299606065375';
        var cookieExpiry = 1;
        expires.setTime(expires.getTime() + (cookieExpiry * 24 * 60 * 60 * 1000));
        document.cookie = cookieKey + '=' + cookieValue + ';expires=' + expires.toUTCString();
        if(jQuery('body').find('#freeMiniShinProduct').length>0){
          jQuery('#freeMiniShinProduct').hide();
        }
      }
    }
    if(jQuery('body').find('.freeshipad-vtwo.style_two').length>0 && getCookie('freeProductId')==null){
      if(jQuery('.freeshipad-vtwo').hasClass("style_two")){
        items.push({id:44299606065375,quantity: 1,properties:{'_freeProduct':'1'}});
        var expires = new Date();
        var cookieKey = 'freeProductId';
        var cookieValue = '44299606065375';
        var cookieExpiry = 1;
        expires.setTime(expires.getTime() + (cookieExpiry * 24 * 60 * 60 * 1000));
        document.cookie = cookieKey + '=' + cookieValue + ';expires=' + expires.toUTCString();
      }
    }

    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        var tempShippingProtect = 0;
        if (cart.items.length > 0) {
          cart.items.forEach(function(itemtemp) {
            //console.log("item.id-pdp->", itemtemp.id)
            if(itemtemp.properties['_type'] === 'shipping_product') {
              tempShippingProtect = 1; // Shipping product exists
            }
          });
          
          //console.log("tempShippingProtect--PDP->", tempShippingProtect);
          if (tempShippingProtect == 0) {
            var properties = {};
            properties['_type'] = 'shipping_product';
            items.push({
              id: 46076881895582,
              quantity: 1,
              properties:properties
            });
          }
        }
        else{
          //console.log("elset--->")
          var properties = {};
          properties['_type'] = 'shipping_product';
          items.push({
            id: 46076881895582,
            quantity: 1,
            properties:properties
          });
          //console.log("item---->", items)
        }
      }
    });
    if (
      !localStorage.getItem("v5-viewed") &&
      document.querySelector('.apex-upsell-modal[data-type="upsell-v5"]')
    ) {
      document.querySelector(
        '.apex-upsell-modal[data-type="upsell-v5"]'
      ).style.display = "block";
      window.mainSelectedVariant = {
        id: mainProductVariantId,
        quantity: mainProductQuantity,
      };
      localStorage.setItem("v5-viewed", "true");

      this.classList.remove("btn--loading");
      this.removeAttribute("disabled");
    } 
    else if (
      !localStorage.getItem("v6-viewed") &&
      document.querySelector('.apex-upsell-modal[data-type="upsell-v6"]')
    ) {
      document.querySelector(
        '.apex-upsell-modal[data-type="upsell-v6"]'
      ).style.display = "block";
      window.mainSelectedVariant = {
        id: mainProductVariantId,
        quantity: mainProductQuantity,
      };
      localStorage.setItem("v6-viewed", "true");

      this.classList.remove("btn--loading");
      this.removeAttribute("disabled");
    } 
    else {
      const checkedProducts = document.querySelectorAll(
        "[name='apex-upsell-product']:checked"
      );
      checkedProducts.forEach(function (ck) {
        const selectElement =
          ck.parentElement.parentElement.querySelector(
            ".apex-upsell-options select"
          );
        const inputElement =
          ck.parentElement.parentElement.querySelector(
            "input[type='hidden']"
          );
        
        let variantId;
        if (selectElement) {
          const selectValue = selectElement.value || selectElement.defaultValue;
          variantId = selectValue;
        } else {
          variantId = inputElement.value || inputElement.defaultValue;
        }

        items.push({
          id: variantId,
          quantity: 1,
        });
      });
      
      let formData = {
        items,
      };

      console.log({items})
      setTimeout(function(){
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            if (!response.ok) {
              alert('Cart Error : Variant can only be purchased with a selling plan.');
              return false;
            }
            theme.ajaxCart.update();

            this.classList.remove("btn--loading");
            this.removeAttribute("disabled");
            
            return response.json();
          })
          .catch((error) => {
            console.error("Error:", error);

            this.classList.remove("btn--loading");
            this.removeAttribute("disabled");
          });
      },500);
    }
  });


document
  .querySelector("button[name='add_bundle_custom']")
  .addEventListener("click", function (e) {
    // Get the active bundle item
    this.classList.add("btn--loading");
    this.setAttribute("disabled", "disabled");
    var btnForm = this;
    const activeItem = document.querySelector('.custom_bundle_item.active');
    if (activeItem) {
      var cpSizeActive = activeItem.querySelectorAll('.cp_size_select.active');
      // Final array to store items
      let itemsArray = [];
      cpSizeActive.forEach((bunelitem)=>{
        // Get variant id from selected option
        let variantId = bunelitem.value;  // replace later with correct variant ID

        // Push into array
        itemsArray.push({
          id: variantId,
          quantity: 1
        });
      });

      console.log("itemsArray-->", itemsArray)

      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          var tempShippingProtect = 0;
          if (cart.items.length > 0) {
            cart.items.forEach(function(itemtemp) {
              //console.log("item.id-pdp->", itemtemp.id)
              if(itemtemp.properties['_type'] === 'shipping_product') {
                tempShippingProtect = 1; // Shipping product exists
              }
            });
            
            //console.log("tempShippingProtect--PDP->", tempShippingProtect);
            if (tempShippingProtect == 0) {
              var properties = {};
              properties['_type'] = 'shipping_product';
              itemsArray.push({
                id: '46076881895582',
                quantity: 1,
                properties:properties
              });
            }
          }
          else{
            //console.log("elset--->")
            var properties = {};
            properties['_type'] = 'shipping_product';
            itemsArray.push({
              id: '46076881895582',
              quantity: 1,
              properties:properties
            });
            //console.log("item---->", items)
          }
        }
      });
      
      setTimeout(function(){
        console.log({itemsArray})
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: itemsArray }),
        })
        .then((response) => {
          if (!response.ok) {
            alert('Cart Error : Variant can only be purchased with a selling plan.');
            return false;
          }
          theme.ajaxCart.update();
          console.log("btnForm---<", btnForm)
          btnForm.classList.remove("btn--loading");
          btnForm.removeAttribute("disabled");
          
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);

          btnForm.classList.remove("btn--loading");
          btnForm.removeAttribute("disabled");
        });
      },1000);
    }
    else{
      btnForm.classList.remove("btn--loading");
      btnForm.removeAttribute("disabled");
    }
});

multiAddBtn.forEach((m) =>
  m.addEventListener("click", function () {
    const items = JSON.parse(this.dataset.selected);

    items.push(window.mainSelectedVariant);

    let formData = {
      items,
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        this.setAttribute("data-selected", "[]");
        this.setAttribute("disabled", "disabled");
        theme.ajaxCart.update();
        this.closest(".apex-upsell-modal").style.display = "none";
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  })
);

/*const bundleUpsell = document.querySelectorAll(".bundle_upsell_snippet button");
bundleUpsell.forEach((btn) =>
  btn.addEventListener("click", function () {

    var vcount = this.getAttribute("data-vcount");
    console.log("vcount-->", vcount);
    let variantId;
    if(vcount > 1){
      const selectElement =
        this.parentElement.querySelector(
          ".bu_product_btn select"
        );
      selectElement.style.display = "";
      $(this).hide();
    }
    else{
      const inputElement =
        this.parentElement.querySelector(
          "input[type='hidden']"
        );
      variantId = inputElement.value || inputElement.defaultValue;

      let items = [
        {
          id: variantId,
          quantity: 1,
        },
      ];

      let formData = {
        items,
      };

      console.log({items})

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
      .then((response) => {
        theme.ajaxCart.update();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    }
  })
);

const selectUpsell = document.querySelectorAll(".bundle_upsell_snippet select");
selectUpsell.forEach((sel) =>
  sel.addEventListener("change", function () {

    let variantId;
    const selectElement =
      this.parentElement.querySelector(
        ".bu_product_btn select"
      );
    if (selectElement) {
      $(this).addClass('btn--loading');
      const selectValue = selectElement.value || selectElement.defaultValue;
      variantId = selectValue;

      let items = [
        {
          id: variantId,
          quantity: 1,
        },
      ];

      let formData = {
        items,
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
      .then((response) => {
        theme.ajaxCart.update();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });

      setTimeout(function() {
        $(this).hide();
        $('button.bu_product_btnlink').show();
      }, 1500);
    }
  })
);*/